import {
    MdHealthAndSafety,
    MdLocalHospital,
    MdBuild,
    MdAutoFixHigh,
    MdMedicalServices,
    MdHealing,
    MdFace,
    MdStraighten,
    MdAssessment,
    MdBedtime,
    MdChildCare,
    MdRateReview,
    MdLocalFireDepartment,
    MdContentCut
} from 'react-icons/md';

const getServicesData = (t) => [
    {
        'icon': <MdHealthAndSafety size={40} />,
        'title': t('services.prophylaxe.title'),
        'description': t('services.prophylaxe.description'),
    },
    {
        'icon': <MdLocalHospital size={40} />,
        'title': t('services.parodontitisbehandlung.title'),
        'description': t('services.parodontitisbehandlung.description'),
    },
    {
        'icon': <MdBuild size={40} />,
        'title': t('services.wurzelbehandlungen.title'),
        'description': t('services.wurzelbehandlungen.description'),
    },
    {
        'icon': <MdAutoFixHigh size={40} />,
        'title': t('services.fuellungen.title'),
        'description': t('services.fuellungen.description'),
    },
    {
        'icon': <MdHealing size={40} />,
        'title': t('services.zahnersatz.title'),
        'description': t('services.zahnersatz.description'),
    },
    {
        'icon': <MdMedicalServices size={40} />,
        'title': t('services.zahnimplantate.title'),
        'description': t('services.zahnimplantate.description'),
    },
    {
        'icon': <MdRateReview size={40} />,
        'title': t('services.zweitmeinung.title'),
        'description': t('services.zweitmeinung.description'),
    },
    {
        'icon': <MdLocalFireDepartment size={40} />,
        'title': t('services.komplexeEntzuendungen.title'),
        'description': t('services.komplexeEntzuendungen.description'),
    },
    {
        'icon': <MdContentCut size={40} />,
        'title': t('services.chirurgischeZahnentfernung.title'),
        'description': t('services.chirurgischeZahnentfernung.description'),
    },
    {
        'icon': <MdFace size={40} />,
        'title': t('services.zahnaesthetik.title'),
        'description': t('services.zahnaesthetik.description'),
    },
    {
        'icon': <MdStraighten size={40} />,
        'title': t('services.alignerZahnschienen.title'),
        'description': t('services.alignerZahnschienen.description'),
    },
    {
        'icon': <MdAssessment size={40} />,
        'title': t('services.funktionsdiagnostik.title'),
        'description': t('services.funktionsdiagnostik.description'),
    },
    {
        'icon': <MdBedtime size={40} />,
        'title': t('services.schnarchschienen.title'),
        'description': t('services.schnarchschienen.description'),
    },
    {
        'icon': <MdChildCare size={40} />,
        'title': t('services.kinderzahnheilkunde.title'),
        'description': t('services.kinderzahnheilkunde.description'),
    }
]

export default getServicesData;